import React, { useState, useEffect } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import api from '../../utils/api';
import { Link } from "react-router-dom";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import {
  Box, Button, Collapse, FormControl, IconButton, InputLabel, MenuItem,
  Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, Typography, Menu, ListItemIcon, ListItemText, Pagination,
} from '@mui/material';
import { ExpandMore, ExpandLess, Search,  History, MoreVert, Add, Edit } from '@mui/icons-material';
import Navbar from '../Layouts/Navbar';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import HistoriqueModal from './HistoriqueModal';
import AddModal from './AddModal';
import UpdateModal from './UpdateModal';





export default function ShiftTable() {

    const [openadd, setOpenAdd] = useState(false);
    const handleOpenAdd = () => setOpenAdd(true);
    const handleCloseAdd = () => setOpenAdd(false);

    const [openupd, setOpenUpd] = useState(false);
    const handleOpenUpd = () => setOpenUpd(true);
    const handleCloseUpd = () => setOpenUpd(false);
    
    const [openhis, setOpenHis] = useState(false);
    const handleOpenHis = () => setOpenHis(true);
    const handleCloseHis = () => setOpenHis(false);


  const [snack, setSnack] = useState({ open: false, message: '', type: 'success' });
  const handleSnack = (message, type = 'success') => {
    setSnack({ open: true, message, type });
  };
  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ ...snack, open: false });
  };
  const handleDelete = async () => {
    try {
      if (!menuRowId) return;
      
      await api.delete(`/shifts/${menuRowId}`);
      fetchShifts(); // Refresh the list
      handleSnack('Shift supprimé avec succès', 'success');
      handleMenuClose();
      setSelected([]);
    } catch (error) {
      console.error('Error deleting shift:', error);
      
      // Gestion détaillée des erreurs
      if (error.response) {
        const { status } = error.response;
        
        if (status === 404) {
          // Ressource non trouvée
          handleSnack("Le shift n'existe pas ou a déjà été supprimé", 'error');
        } else if (status === 403) {
          // Accès interdit
          handleSnack("Vous n'avez pas les droits pour supprimer ce shift", 'error');
        } else if (status === 500) {
          // Erreur serveur
          handleSnack("Erreur serveur lors de la suppression du shift", 'error');
        } else {
          // Autres erreurs HTTP
          handleSnack(`Erreur lors de la suppression du shift (${status})`, 'error');
        }
      } else if (error.request) {
        // Erreur réseau - pas de réponse
        handleSnack("Erreur réseau. Vérifiez votre connexion internet", 'error');
      } else {
        // Autres erreurs
        handleSnack("Erreur lors de la suppression du shift", 'error');
      }
    }
  };
  
  const handleConfirmDeleteOpen = () => {
    setOpenConfirmDelete(true);
  };
  
  const handleConfirmDeleteClose = () => {
    setOpenConfirmDelete(false);
  };
  
  const handleGroupDelete = async () => {
    if (selected.length === 0) {
      handleSnack('Aucun shift sélectionné', 'error');
      return;
    }
    
    try {
      // Utiliser Promise.allSettled pour suivre les succès et les échecs individuels
      const results = await Promise.allSettled(selected.map(id => api.delete(`/shifts/${id}`)));
      
      // Compter les succès et les échecs
      const successCount = results.filter(result => result.status === 'fulfilled').length;
      const failureCount = results.filter(result => result.status === 'rejected').length;
      
      fetchShifts(); // Refresh the list
      
      // Message basé sur les résultats
      if (successCount === selected.length) {
        // Tous les shifts ont été supprimés avec succès
        handleSnack(`${successCount} shift(s) supprimé(s) avec succès`, 'success');
      } else if (successCount > 0) {
        // Certains shifts ont été supprimés, d'autres ont échoué
        handleSnack(`${successCount} shift(s) supprimé(s) avec succès, ${failureCount} échec(s)`, 'warning');
      } else {
        // Aucun shift n'a été supprimé
        handleSnack(`Échec de la suppression des ${failureCount} shift(s)`, 'error');
      }
      
      setSelected([]);
      handleConfirmDeleteClose();
    } catch (error) {
      console.error('Error in bulk delete operation:', error);
      
      // Gestion des erreurs générales (comme les erreurs réseau)
      if (error.request) {
        // Erreur réseau - pas de réponse
        handleSnack("Erreur réseau. Vérifiez votre connexion internet", 'error');
      } else {
        // Autres erreurs
        handleSnack("Erreur lors de la suppression des shifts", 'error');
      }
    }
  };
  
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  
  const handleSelectOne = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    
    setSelected(newSelected);
  };
  
  const isSelected = (id) => selected.indexOf(id) !== -1;
  


  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [menuRowId, setMenuRowId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  
  // State for data management
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sites, setSites] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchSite, setSearchSite] = useState('');
  const [searchDirection, setSearchDirection] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  const [selectedShift, setSelectedShift] = useState(null);
  const [selected, setSelected] = useState([]);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  
  // Fetch shifts data
  useEffect(() => {
    fetchShifts();
    fetchSites();
  }, []);
  
  const fetchShifts = async () => {
    setLoading(true);
    try {
      const response = await api.get('/shifts');
      setRows(response.data.map(shift => ({
        id: shift.ID_Shift,
        name: shift.name,
        site: shift.site ? shift.site.name : '',
        siteId: shift.ID_Site,
        direction: shift.Direction || '',
        statut: shift.Status || 'Active'
      })));
    } catch (error) {
      console.error('Error fetching shifts:', error);
      handleSnack('Erreur lors du chargement des shifts', 'error');
    } finally {
      setLoading(false);
    }
  };
  
  const fetchSites = async () => {
    try {
      const response = await api.get('/sites');
      setSites(response.data || []);
    } catch (error) {
      console.error('Error fetching sites:', error);
    }
  };
  
  

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(id);
    const shift = rows.find(row => row.id === id);
    if (shift) {
      setSelectedShift(shift);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1); // reset to first page when rows per page change
  };

  // Search functionality
  const handleSearch = () => {
    fetchShifts();
  };
  
  const handleReset = () => {
    setSearchKeyword('');
    setSearchSite('');
    setSearchDirection('');
    setSearchStatus('');
    fetchShifts();
  };
  
  // Filter rows based on search criteria
  const filteredRows = rows.filter(row => {
    const matchesKeyword = searchKeyword ? 
      row.name.toLowerCase().includes(searchKeyword.toLowerCase()) : true;
    
    const matchesSite = searchSite ? 
      row.siteId === searchSite : true;
    
    const matchesDirection = searchDirection ? 
      row.direction === searchDirection : true;
    
    const matchesStatus = searchStatus ? 
      row.statut === searchStatus : true;
    
    return matchesKeyword && matchesSite && matchesDirection && matchesStatus;
  });
  
  const paginatedRows = filteredRows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(filteredRows.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <AccessTimeFilledIcon />
            <Typography variant="h6">SHIFTS</Typography>
          </Box>
          <Button
           onClick={handleOpenAdd}
          variant="outlined" sx={{
            color: 'red',
            borderColor: 'red',
            textTransform: 'none',
            '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
          }} startIcon={<Add />}>Ajouter</Button>
        </Box>

        {/* Search Section */}
        <Paper variant="outlined" sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1} mt={1} onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <Search />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>RECHERCHER</Typography>
            <IconButton>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
        </Paper>

        <Collapse in={open}>
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Box display="flex" gap={2} mb={2}>
            <TextField
                label="Mot cle"
                InputLabelProps={{ shrink: true }}
                fullWidth size="small"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  },
                  '& .MuiInputLabel-root': {
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                  }
                }}
              />
                <FormControl fullWidth size="small" sx={{
                    '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                    }
                }}>
                    <InputLabel sx={{
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                    }}>Site</InputLabel>
                    <Select 
                      label="Site"
                      value={searchSite}
                      onChange={(e) => setSearchSite(e.target.value)}
                    >
                      <MenuItem value="">Tous les sites</MenuItem>
                      {sites.map(site => (
                        <MenuItem key={site.ID_Site} value={site.ID_Site}>
                          {site.name}
                        </MenuItem>
                      ))}
                    </Select>
                </FormControl>
                <FormControl fullWidth size="small" sx={{
                    '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                    }
                }}>
                    <InputLabel sx={{
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                    }}>Direction</InputLabel>
                    <Select 
                      label="Direction"
                      value={searchDirection}
                      onChange={(e) => setSearchDirection(e.target.value)}
                    >
                      <MenuItem value="">Toutes les directions</MenuItem>
                      <MenuItem value="Entrée">Entrée</MenuItem>
                      <MenuItem value="Sortie">Sortie</MenuItem>
                    </Select>
                </FormControl>
                <FormControl fullWidth size="small" sx={{
                    '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                    }
                }}>
                    <InputLabel sx={{
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                    }}>Statut</InputLabel>
                    <Select 
                      label="Statut"
                      value={searchStatus}
                      onChange={(e) => setSearchStatus(e.target.value)}
                    >
                      <MenuItem value="">Tous les statuts</MenuItem>
                      <MenuItem value="Active">Actif</MenuItem>
                      <MenuItem value="Inactive">Inactif</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Button 
                variant="outlined" 
                onClick={handleReset}
                sx={{
                  color: 'red',
                  borderColor: 'red',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                }}
              >
                Reset
              </Button>
              <Button 
                variant="outlined" 
                onClick={handleSearch}
                sx={{
                  color: 'red',
                  borderColor: 'red',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                }}
              >
                Search
              </Button>
            </Box>
          </Paper>
        </Collapse>

        {/* Bulk Actions */}
        {selected.length > 0 && (
          <Paper variant="outlined" sx={{ p: 2, mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1">
              {selected.length} sélectionné(s)
            </Typography>
            <Button
              variant="outlined"
              color="error"
              onClick={handleConfirmDeleteOpen}
              startIcon={<DeleteIcon />}
              sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}
            >
              Supprimer
            </Button>
          </Paper>
        )}
        
        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
        <Table>
            <TableHead>
            <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                color="primary"
                indeterminate={selected.length > 0 && selected.length < rows.length}
                checked={rows.length > 0 && selected.length === rows.length}
                onChange={handleSelectAll}
                sx={{
                  '&.Mui-checked': { color: 'red' },
                  '&.MuiCheckbox-indeterminate': { color: 'red' },
                }}
              />
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Site</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Statut</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
                    {paginatedRows.map((row, index) => (
                    <TableRow 
                      key={row.id} 
                      hover
                      selected={isSelected(row.id)}
                      sx={{
                        '&.Mui-selected': {
                          backgroundColor: 'rgba(255, 0, 0, 0.08)',
                          '&:hover': {
                            backgroundColor: 'rgba(255, 0, 0, 0.12)',
                          },
                        },
                      }}
                    >
                    <TableCell padding="checkbox">
                      <Checkbox
                        color="primary"
                        checked={isSelected(row.id)}
                        onChange={(event) => handleSelectOne(event, row.id)}
                        sx={{
                          '&.Mui-checked': { color: 'red' },
                        }}
                      />
                    </TableCell>
                    <TableCell>{row.id}</TableCell>   
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.site}</TableCell>
                    <TableCell>
                    <Box
                        sx={{
                        backgroundColor: row.statut === 'Actif' || row.statut === 'Active' ? '#4caf50' : '#dc3545',
                        color: 'white',
                        borderRadius: '4px',
                        px: 1,
                        py: 0.5,
                        display: 'inline-block',
                        fontSize: '0.8rem',
                        textAlign: 'center',
                        minWidth: '60px',
                        }}
                    >
                        {row.statut}
                    </Box>
                    </TableCell>
                    <TableCell>
                    <IconButton onClick={(e) => handleMenuClick(e, row.id)}>
                        <MoreVert />
                    </IconButton>
                    <Menu
                        anchorEl={anchorEl}
                        open={menuRowId === row.id && openMenu}
                        onClose={handleMenuClose}
                        PaperProps={{
                        sx: {
                            minWidth: '200px',
                            '& .MuiMenuItem-root': {
                            color: 'black',
                            '& .MuiListItemIcon-root': { color: 'black' },
                            '&:hover': {
                                backgroundColor: 'red',
                                color: 'white',
                                '& .MuiListItemIcon-root': { color: 'white' },
                            },
                            },
                        },
                        }}
                    >
                        <MenuItem onClick={() => {
                          handleOpenUpd();
                          handleMenuClose();
                        }}>
                        <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
                        <ListItemText>Modifier</ListItemText>
                        </MenuItem>
                        <MenuItem sx={{ color: 'red' }} onClick={handleOpenHis}>
                        <ListItemIcon sx={{ color: 'red' }}><History fontSize="small" /></ListItemIcon>
                        <ListItemText>Historique</ListItemText>
                        </MenuItem>
                    </Menu>
                    </TableCell>
                </TableRow>
                 ))}
            </TableBody>
        </Table>
        </TableContainer>


        {/* Pagination + entries info */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{rows.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              }
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>

      </Box>
      <Snackbar open={snack.open} autoHideDuration={3000} onClose={handleCloseSnack} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={handleCloseSnack} severity={snack.type} elevation={6} variant="filled" sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}>
            {snack.message}
        </MuiAlert>
        </Snackbar>

    <HistoriqueModal open={openhis} handleClose={handleCloseHis} />
    <AddModal 
      open={openadd} 
      handleClose={handleCloseAdd} 
      handleSnack={handleSnack}
      onSuccess={fetchShifts}
    />
    <UpdateModal 
      open={openupd} 
      handleClose={handleCloseUpd} 
      handleSnack={handleSnack}
      selectedRow={selectedShift}
      onSuccess={fetchShifts}
    />
    
    {/* Confirm Delete Dialog */}
    <Dialog
      open={openConfirmDelete}
      onClose={handleConfirmDeleteClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Confirmer la suppression"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Êtes-vous sûr de vouloir supprimer {selected.length} shift(s) ? Cette action est irréversible.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirmDeleteClose} sx={{ color: 'gray' }}>
          Annuler
        </Button>
        <Button onClick={handleGroupDelete} autoFocus sx={{ color: 'red' }}>
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
</Box>

    
  );
}
